import { EntityList } from '@/common/entityFramework/entityList/EntityList'
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const InvLineList = ({ invObj: inv }) => {
  
  const augRowsReq = useCallback((rowsReq) => {
    if (!inv) return;
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('invDate', inv.invDate,'invId', inv.id));
  }, [inv.id]);

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons);
  }

  return (
    <EntityList entity="INV_LINE" augRowsReq={augRowsReq} augTabButtons={augTabButtons}/>
  )
}
